export default {
  type: "Feature",
  properties: {
    name: "Сайншанд",
    location: [44.37015, 109.33032],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [108.55899810791016, 45.94112327491896],
        [108.56826782226561, 45.95878764035642],
        [108.599853515625, 45.98837476770814],
        [108.62457275390625, 46.08275685027116],
        [108.66989135742188, 46.18363372751015],
        [108.720703125, 46.214050815339526],
        [108.83331298828124, 46.3023549043942],
        [108.90884399414062, 46.38246489326114],
        [108.92669677734374, 46.42365918046987],
        [108.95965576171875, 46.464349400461124],
        [108.95828247070312, 46.464349400461124],
        [109.12170410156249, 46.37725420510028],
        [109.149169921875, 46.29001987172955],
        [109.21508789062499, 46.22545288226939],
        [109.324951171875, 46.16841886922939],
        [109.5172119140625, 46.16841886922939],
        [109.6160888671875, 46.14939437647686],
        [109.8797607421875, 46.26724020382508],
        [109.9346923828125, 46.33934333161126],
        [110.0115966796875, 46.46056554578543],
        [109.97863769531249, 46.60039303734547],
        [110.0225830078125, 46.63057868059483],
        [110.12695312499999, 46.604167162931844],
        [110.2093505859375, 46.51351558059737],
        [110.379638671875, 46.384833223492784],
        [110.511474609375, 46.229253045075275],
        [110.5609130859375, 46.0998999106273],
        [110.950927734375, 46.06560846138691],
        [111.05529785156249, 46.15700496290803],
        [111.1651611328125, 46.23685258143992],
        [111.16653442382812, 46.230203044669985],
        [111.36566162109375, 46.17412493440401],
        [111.5057373046875, 46.115133713265415],
        [111.57989501953125, 46.09418614922648],
        [111.61834716796875, 46.06179698466216],
        [111.70074462890625, 45.922497984579934],
        [111.7144775390625, 45.72727377526009],
        [111.68426513671875, 45.533288879467456],
        [111.7529296875, 45.49287107405929],
        [111.80511474609375, 45.41002023463975],
        [111.9012451171875, 45.321254361171476],
        [111.9232177734375, 45.27681919090837],
        [111.91223144531249, 45.21687321093267],
        [111.91223144531249, 45.17235628126675],
        [111.939697265625, 45.08758121648526],
        [111.95343017578125, 45.071944633095136],
        [111.95274353027344, 45.07303569638012],
        [111.785888671875, 45.00365115687189],
        [111.544189453125, 44.653024159812],
        [111.55517578125, 44.574817404670306],
        [111.46728515624999, 44.4808302785626],
        [111.4013671875, 44.33170718680922],
        [111.52221679687499, 44.284536706018905],
        [111.52221679687499, 44.18220395771566],
        [111.654052734375, 44.05601169578525],
        [111.87377929687499, 43.92163712834673],
        [111.961669921875, 43.79488907226601],
        [111.939697265625, 43.691707903073805],
        [111.77490234375, 43.65197548731187],
        [111.566162109375, 43.476840397778915],
        [111.412353515625, 43.48481212891603],
        [111.324462890625, 43.42100882994726],
        [111.005859375, 43.33316939281735],
        [110.72021484375, 43.08493742707592],
        [110.643310546875, 42.94838139765314],
        [110.45654296875, 42.84375132629021],
        [110.445556640625, 42.79540065303723],
        [110.14892578125, 42.68243539838623],
        [110.10498046875, 42.633958722673164],
        [109.896240234375, 42.633958722673164],
        [109.6875, 42.577354839557856],
        [109.522705078125, 42.4639928001706],
        [109.2919921875, 42.439674178149424],
        [109.017333984375, 42.45588764197166],
        [108.83056640625, 42.382894009614056],
        [108.533935546875, 42.439674178149424],
        [108.270263671875, 42.439674178149424],
        [108.2427978515625, 42.45791402988027],
        [108.0120849609375, 42.43359304732316],
        [107.9791259765625, 42.413318349422475],
        [107.9791259765625, 42.412304442420684],
        [107.98393249511719, 42.42877840024783],
        [107.9791259765625, 42.589488572714245],
        [108.00933837890625, 42.70060440808085],
        [108.0120849609375, 42.85381962412133],
        [108.0340576171875, 42.93631775765237],
        [108.017578125, 43.0287452513488],
        [108.00384521484375, 43.17113228474479],
        [107.95166015624999, 43.257205668363206],
        [107.9296875, 43.31118965238512],
        [107.93792724609375, 43.52266348752663],
        [107.9571533203125, 43.61619382369188],
        [107.95440673828125, 43.69766549666678],
        [107.85552978515625, 43.90778718292443],
        [107.83355712890625, 43.98886243884903],
        [107.7923583984375, 44.109281923355645],
        [107.64678955078125, 44.30419567985762],
        [107.64816284179686, 44.36313311380771],
        [107.68798828125, 44.555249259710656],
        [107.68661499023436, 44.554026032095756],
        [107.71270751953125, 44.57383915375391],
        [107.74017333984375, 44.60904581939581],
        [107.76489257812499, 44.66083904265621],
        [107.79510498046875, 44.75746105408348],
        [107.84042358398438, 44.86852295681338],
        [107.91183471679688, 44.86852295681338],
        [108.02169799804686, 44.87630874326681],
        [108.24966430664062, 44.87630874326681],
        [108.41583251953125, 44.88506649401471],
        [108.41583251953125, 44.92786297463683],
        [108.42269897460938, 44.968684437948376],
        [108.4405517578125, 45.02889163330817],
        [108.46595764160155, 45.06770141120143],
        [108.511962890625, 45.08564202775547],
        [108.58474731445312, 45.101638366018676],
        [108.65272521972655, 45.10793872360393],
        [108.52294921875, 45.36372498305678],
        [108.5174560546875, 45.41773242370463],
        [108.468017578125, 45.590978249451936],
        [108.47763061523438, 45.68795490838444],
        [108.49411010742188, 45.769438866203934],
        [108.53530883789062, 45.89000815866184],
        [108.55899810791016, 45.941362020083915],
        [108.55899810791016, 45.94112327491896],
      ],
    ],
  },
};
